import * as i18nActions from '@app/core/i18n/store/actions';
import { I18nCountry, I18nLanguage, I18nCurrency } from '@app/core/i18n/models/interfaces';

export interface I18nState {
  country: I18nCountry;
  language: I18nLanguage;
  currency: I18nCurrency;
  directShippingEligible: boolean;
}

const initialState: I18nState = {
  country: {
    id: '',
    isoCode: '',
    idRegion: '',
    name: ''
  },
  currency: {
    id: '0',
    isoCode: '',
    name: '',
    symbol: ''
  },
  language: {
    isoCode: '',
    name: ''
  },
  directShippingEligible: false
};

export function reducer(state: any = initialState, action: i18nActions.All): I18nState {
  switch (action.type) {
    case i18nActions.UPDATE_LANGUAGE:
      return {
        ...state,
        ...{
          language: action.payload
        }
      };

    case i18nActions.UPDATE_CURRENCY:
      return {
        ...state,
        ...{
          currency: action.payload
        }
      };

    case i18nActions.UPDATE_COUNTRY:
      return {
        ...state,
        ...{
          country: action.payload
        }
      };

    case i18nActions.SET_DIRECT_SHIPPING_ELIGIBILITY:
      return {
        ...state,
        ...{
          directShippingEligible: action.payload
        }
      };

    default:
      return state;
  }
}

export const getUserCurrency = (state: I18nState) => state.currency;
export const getUserLang = (state: I18nState) => state.language;
export const getUserCountry = (state: I18nState) => state.country;
export const getDirectShipping = (state: I18nState) => state.directShippingEligible;
